import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from '@commoncore/services/logger.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { ContextMenuMobileService } from './context-menu-mobile.service';
import { LocalStorageSvc } from './localStorage.service';
import { SessionStorageService } from './session-storage.service';
import { ActiveRepo, UniversalService } from './universal.service';


@Injectable({
  providedIn: 'root'
})
export class ContextMenuService {
  private favoritesMenu:any;
  private sharedByMe :any;
  private sharedWithMe :any;
  private officeForWeb : any;
  filesNotOwnedByUser:any =[];
  // actualContextMenuPosition:any;
  


  constructor(public universalService:UniversalService,public contextMenuMobileService:ContextMenuMobileService,public router:Router,public loggerService:LoggerService,public http:HttpClient,private localStorageSvc:LocalStorageSvc,private sessionStorageService:SessionStorageService) {
    
   }


  showCustomContextMenu(e) { 
    this.universalService.showAutoSuggestion = false;
    this.universalService.operationInProgress = false;
    this.universalService.openMoreOptionsContextMenu = false;
    this.universalService.openMoreOptions = false;
    this.universalService.removeHighlightFromSelectedOption();
    var classRef = this.universalService
    if(classRef.isMobileDevice) {
      return false;
    } else {
      this.hideCustomContextMenu();
      setTimeout(() => {
        this.decideContextMenuItems();
        // this.actualContextMenuPosition = e.clientX;
        $("#customContextMenu").css("display", "block");
        $("#customContextMenu").css('--mouse-x', e.clientX + 'px');
        $("#customContextMenu").css('--mouse-y', e.clientY + 'px');
        jQuery("#customContextMenu").show();
      }, 10);
      
      classRef.showContextMenu = true;
      
      e.stopPropagation();
      e.preventDefault();  
    }
  }
  hideCustomContextMenu() {
    var classRef = this.universalService;
    classRef.showContextMenu = false;
    jQuery("#customContextMenu").hide();
    this.hideCustomMoreOptionsContextMenu();
  }

  hideCustomMoreOptionsContextMenu(){
    var classRef = this.universalService;
    jQuery(".moreOptionsCustomContextMenu").hide();
  }

  showCustomMoreOptionsContextMenu(e,indexOfItemWhereMoreOptionsMenuShouldOpen){
    this.universalService.operationInProgress = false;
    var classRef = this.universalService
    if(classRef.isMobileDevice) {
      return false;
    } else {
      this.hideCustomMoreOptionsContextMenu();
      var width = $(".customContextMenu").offset().left + $(".contextMenuItemDiv").outerWidth();
      setTimeout(() => {
        if(width > window.innerWidth - $(".contextMenuMoreOptionsItemDiv").innerWidth()){
          width = $(".customContextMenu").offset().left - $(".contextMenuMoreOptionsItemDiv").outerWidth();
        }
        var height = $(".contextMenuItemDiv").outerHeight();
        $(".moreOptionsCustomContextMenu").css("display", "block");
        $(".moreOptionsCustomContextMenu").css('--mouse-x', width  + 'px');
        $(".moreOptionsCustomContextMenu").css('--mouse-y', $(".customContextMenu").offset().top + (height*indexOfItemWhereMoreOptionsMenuShouldOpen) + 'px');
      }, 10);
      jQuery(".moreOptionsCustomContextMenu").show();
      e.stopPropagation();
      e.preventDefault();  
    }
  }


  decideContextMenuItems(){
    var self = this;
    var classRef = this.universalService;
    self.resetOptionMenus();
    if(classRef.isMobileDevice){
      self.contextMenuMobileService.decideContextMenuItemsForMobile();
    }else{
      self.decideContextMenuItemsForDesktop();
    }
  }

  resetOptionMenus(){
    var classRef = this.universalService;
    classRef.moreOptionsOnMobileClicked = false;
    classRef.moreOptionsSubMenu = [];
    // classRef.contextMenuOptions = []; // not resetting this to empty, as default context menu should get populated when user clicks in blank area
    classRef.topMenuOptions = [];
    classRef.moreOptionsOnTopMenu = [];
    classRef.middleMenuOptionsMobile = [];
    classRef.bottomMenuOptionsMobile = [];
  }

  decideContextMenuItemsForDesktop(){ 
    var classRef = this.universalService;
    var userData = this.localStorageSvc.getUserData(true);
    if(classRef.activeRepo == ActiveRepo.SHARE){
      classRef.isFolderPresent();
      if(classRef.showAddToJioCloudOnTopMenu){
        if(classRef.selectedNodes.length == 1){
          if(classRef.showPreview == true){
            if(classRef.selectedFile["mimeType"] == "image"){
              classRef.topMenuOptions = classRef.topMenu_Share["singleFile"]["preview_Image_FileMenu"]["topMenu"]
            }else{
              classRef.topMenuOptions = classRef.topMenu_Share["singleFile"]["preview_Other_Type_FileMenu"]["topMenu"]
            }
            //For video - remove full screen option
            if(classRef.selectedFile["mimeType"] == "video"){
              let options = [];
              classRef.topMenuOptions.map((option)=>{
                if(option["onClick"] != "fullScreen"){
                  options.push(option)
                }
              })
              classRef.topMenuOptions = options;
            }
          }else{
            // single file and no folders  selected
            classRef.contextMenuOptions  = classRef.contextMenu_Share["singleFile"]["FileMenu"];
            classRef.topMenuOptions = classRef.topMenu_Share["singleFile"]["FileMenu"]["topMenu"]
          }
          

        }else if(classRef.selectedNodes.length > 1){
          // mutliple file selected
          classRef.contextMenuOptions  = classRef.contextMenu_Share["multipleFile"]["FileMenu"];
          classRef.topMenuOptions = classRef.topMenu_Share["multipleFile"]["FileMenu"]["topMenu"]
        }
        
        //if(this.router.url.indexOf("?u")>0 && this.localStorageSvc.getUserId(true) == this.localStorageSvc.getShareLinkCreator() ){
        if(this.router.url.indexOf("?u")>0 && userData && userData["userId"] == this.sessionStorageService.getShareLinkCreator() ){
          // remove add to jioclod option
          var topfound = classRef.topMenuOptions.find(k => k["onClick"] == "addToJioCloud")
          if(topfound){
            var index = classRef.topMenuOptions.indexOf(topfound)
            classRef.topMenuOptions.splice(index,1)
          }
          

          var contextfound = classRef.contextMenuOptions.find(k => k["onClick"] == "addToJioCloud")
          if(contextfound){
            var index = classRef.contextMenuOptions.indexOf(contextfound)
            classRef.contextMenuOptions.splice(index,1)
          }
       
        }
      }else{
        if(classRef.selectedNodes.length == 1){
          //single folder selected
          classRef.contextMenuOptions  = classRef.contextMenu_Share["singleFile"]["FolderMenu"];
          classRef.topMenuOptions = classRef.topMenu_Share["singleFile"]["FolderMenu"]["topMenu"];
        }else if (classRef.selectedNodes.length > 1){
          // multiple file including folder selected
          classRef.contextMenuOptions  = classRef.contextMenu_Share["multipleFile"]["FolderMenu"];
          classRef.topMenuOptions = classRef.topMenu_Share["multipleFile"]["FolderMenu"]["topMenu"];

        }
      }

      


    }else if(classRef.activeRepo == ActiveRepo.MAIN){
      if(this.router.url.includes("/memory")){
        this.getContextMenuOptionsForMemory();
        return
      }
      classRef.isFolderPresent();
      if(classRef.showAddToJioCloudOnTopMenu){ // folders are not present in the selected files
        if(classRef.selectedNodes.length == 0){ // this check is when the preview is open and esc is clicked
          return
        }else if(classRef.selectedNodes.length == 1){ // selected items is only 1
          if(classRef.selectedNodes[0]["FullObject"]){
            var file = classRef.selectedNodes[0]["FullObject"]
          }else{
            var file = classRef.selectedNodes[0]
          }
          let previewFromUpload = file["previewFromUpload"];
          if(this.universalService.isUserOnSharedLinkByMe && !previewFromUpload) {
            this.getContextMenuForSharedLinkByMe();
          } else if(file["objectType"] == "FE"){
            if(this.universalService.showPreview == true){
              if((!previewFromUpload && this.router.url.includes('shared')) || (previewFromUpload && file["uploadInitiatedModule"] == "sharedFiles")){
                this.getContextMenuForSingleSharedFile(file)
              } else if((!previewFromUpload && this.router.url.includes('/teamfolders/')) || (!previewFromUpload && this.router.url.includes('/search/tf/')) || (previewFromUpload && file["uploadInitiatedModule"] == "teamfolders")){
                this.getContextMenuForFileEntityPreviewInTeamFolder(file)
              }else if((!previewFromUpload && this.router.url.includes('/privatefolder')) || (previewFromUpload && file["uploadInitiatedModule"] == "PrivateFolder")){
                this.getContextMenuForFileEntityPreviewInPrivateFolder(file)
              }else if(!previewFromUpload && this.router.url.includes("/digilocker")){
                this.getContextMenuForSingleFileEntityPreviewForDigiLocker(file)
              }else if(!previewFromUpload && this.router.url.includes("/jpai")){
                this.getContextMenuForSingleFileEntityPreviewForJioPhoneCallAI()
              }else{
                this.getContextMenuForFileEntityPreview(file)
              }
              //For video - remove full screen option
              if (file["mimeType"] === "video") {
                let options = [];
                classRef.topMenuOptions.map((option)=>{
                  if(option["onClick"] != "fullScreen"){
                    options.push(option)
                  }
                })
                classRef.topMenuOptions = options;
              }
            }else if(this.router.url.includes('trash')){
              this.getContextMenuForTrashFiles();
            }else if(this.router.url.includes('/shared/')){
              this.getContextMenuForSingleSharedFile(file);
            }else{
              this.getContextMenuForSingleFileEntity(file);
            }
          }else if(file["objectType"] != "FE"){
            // this.universalService.fetchJSONContent(); // restricting json calls on evry album file selection and verified 318003(due to which this line was added as a fix)
            if(this.universalService.showPreview == true){
              this.getContextMenuForAlbumEntityPreview(file)
            }else if(this.router.url.includes('trash')){
              this.getContextMenuForTrashFiles();
            }else if(this.router.url.includes('/favorites/')){
              this.getContextMenuForFavoritesTabSingleAlbumFile(file)
            }else{
              this.getContextMenuForSingleAlbumEntity(file);
            }
            //For video - remove full screen option            
            if (file["mimeType"] === "video") {
              let options = [];
              classRef.topMenuOptions.map((option)=>{
                if(option["onClick"] != "fullScreen"){
                  options.push(option)
                }
              })
              classRef.topMenuOptions = options;
            }
          }
          
          if(!this.router.url.includes('trash') && !this.universalService.isUserOnSharedLinkByMe && JSON.stringify(this.universalService.selectedNodes[0]) != "{}"){
            this.checkIfOpenWithOfficeForWebOption(file);
            this.addEditImageOptionIfImageFileIsSelected(file);
          }
        
          if(JSON.stringify(this.universalService.selectedNodes[0]) != "{}"){
            this.checkIfManageVersionsIsTobeSupported(file);
            this.checkIfShowLocationOption();
          }
          this.checkIfUploafFromPreviewAndRemoveUnecessaryOptions(file,this.universalService.moreOptionsOnTopMenu,this.universalService.contextMenuOptions,this.universalService.topMenuOptions);
          this.universalService.showLoader = false;
        }
        
        else{ // selected items are > 1
          this.filesNotOwnedByUser = [];
          var checkForAlbumFiles = [];
          if(this.router.url.includes('/teamfolders/') || this.router.url.includes('/search/tf/')){
            if(classRef.selectedNodes[0]["FullObject"]){
              var file = classRef.selectedNodes[0]["FullObject"]
            }else{
              var file = classRef.selectedNodes[0]
            }
            this.getContextMenuForMultipleSelected(file);
          }else if(this.router.url.includes('/privatefolder')){
            if(classRef.selectedNodes[0]["FullObject"]){
              var file = classRef.selectedNodes[0]["FullObject"]
            }else{
              var file = classRef.selectedNodes[0]
            }
            this.getContextMenuForMultipleSelected(file);
          }else{
            classRef.selectedNodes.filter(objType=>{
              if(objType["FullObject"]){
                if(objType["FullObject"]["objectType"] != "FE")
                checkForAlbumFiles.push(objType)
              }else{
                if(objType["objectType"] != "FE")
                checkForAlbumFiles.push(objType)
              }
            })
            classRef.selectedNodes.filter(objType=>{
              if(objType["FullObject"]){
                if(objType["FullObject"]["isLoggedInUsrAlbumOwner"] ==  false && objType["FullObject"]["isLoggedInUsrFileOwner"] ==  false )
                this.filesNotOwnedByUser.push(objType)
              }else{
                if(objType["isLoggedInUsrFileOwner"] ==  false && objType["isLoggedInUsrAlbumOwner"] ==  false)
                this.filesNotOwnedByUser.push(objType)
              }
            })
            var checkFavoritedFiles = [];
            classRef.selectedNodes.map(fav=>{
              if(fav["FullObject"]){
                if(fav["FullObject"]["isFavorite"] == true)
                checkFavoritedFiles.push(fav)
              }else{  
                if(fav["isFavorite"] == true)
                checkFavoritedFiles.push(fav)
              } 
            })
            if(checkForAlbumFiles.length>=1){
              if(this.router.url.includes('/favorites/')){
                // if the user is on favotites tab
                this.getContextMenuForFavoritesTabMultipleAlbumFiles(checkFavoritedFiles)
              }else if(this.router.url.includes('trash')){
                this.getContextMenuForTrashFiles();
              }else{
                 // selected files are album files
                this.getContextMenuForMultipleAlbumEntities(checkFavoritedFiles);
              }
            }else{ 
              if(this.router.url.includes('trash')){
                this.getContextMenuForTrashFiles();
              }else if(this.router.url.includes('/shared/')){
                this.getContextMenuForMultipleSharedFiles();
              }else{
              // selected files are not album files (repo files)
              this.getContextMenuForMultipleFileEntities(checkFavoritedFiles);
              }
            }
          }
          
        }

      }else{ // folder is present in the selected files
        if(classRef.selectedNodes.length == 1){ // selected item is only 1
          if(classRef.selectedNodes[0]["FullObject"]){
            var folder = classRef.selectedNodes[0]["FullObject"]
          }else{
            var folder = classRef.selectedNodes[0]
          }
          classRef.openMoreOptions = false;
          if(this.universalService.isUserOnSharedLinkByMe) {
            this.getContextMenuForSharedLinkByMe();
          } else if(this.router.url.includes('trash')){
            this.getContextMenuForTrashFiles();
          }else if (this.router.url.includes('/shared/')){
            this.getContextMenuForSingleSharedFolder(folder)
          }else if (this.router.url.includes('/teamfolders/') || this.router.url.includes('/search/tf/')){
            this.getContextMenuForInsideTeamFolders(folder)
          }else if (this.router.url.includes('/privatefolder')){
            this.getContextMenuForInsidePrivateFolder(folder);
          }else if (this.router.url.includes('/teamfolders') && !this.router.url.includes('/teamfolders/')){
            this.getContextMenuForTeamFolders(folder);
          }else if (this.router.url.includes('/jpai')){
            this.getContextMenuForSingleFolderEntityForJioPhoneCallAI();
          }else {
            classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["FolderMenu"];
            classRef.topMenuOptions  = classRef.topMenu_MainRepo["singleFile"]["FolderMenu"]["topMenu"];
            classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["FolderMenu"]["moreOptions"]
          }
          this.checkIfShowLocationOption();
        }else{ //selected items are > 1
          classRef.openMoreOptions = false;
          if(this.router.url.includes('trash')){
            this.getContextMenuForTrashFiles();
          }else if(this.router.url.includes('/shared/')){
            this.getContextMenuForMultipleSharedFolders();
          }else if(this.router.url.includes('/teamfolders/') || this.router.url.includes('/search/tf/')){
            if(classRef.selectedNodes[0]["FullObject"]){
              var file = classRef.selectedNodes[0]["FullObject"]
            }else{
              var file = classRef.selectedNodes[0]
            }
            this.getContextMenuForMultipleSelected(file);
          }else if(this.router.url.includes('/privatefolder')){
            if(classRef.selectedNodes[0]["FullObject"]){
              var file = classRef.selectedNodes[0]["FullObject"]
            }else{
              var file = classRef.selectedNodes[0]
            }
            this.getContextMenuForInsidePrivateFolderMultipleEntity(file);
          }else if(this.router.url.includes('/jpai')){
            this.getContextMenuForMultipleFolderEntitiesForJioPhoneCallAI();
          }else {
          classRef.contextMenuOptions = classRef.contextMenu_MainRepo["multipleFile"]["FolderMenu"];
          classRef.topMenuOptions = classRef.topMenu_MainRepo["multipleFile"]["FolderMenu"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["multipleFile"]["FolderMenu"]["moreOptions"]
          }
        }
        this.removeDownloadOptionFromMenuWhenTheObjectsAreFromDifferentHierarchies();
        if(classRef.selectedNodes.length > 1)
          this.removeShareOptionFromMenuWhenMultipleObject();
      }
      this.checkIfPrivateFolderOptionToShow();
    }else if(classRef.activeRepo == ActiveRepo.INVITE){
      if(classRef.showAddToJioCloudOnTopMenu){ // folders are not present in the selected files
        if(classRef.selectedNodes.length == 0){ // this check is when the preview is open and esc is clicked
          return
        }else if(classRef.selectedNodes.length == 1){ // selected items is only 1
          if(classRef.selectedNodes[0]){
            var file = classRef.selectedNodes[0]
          }else{
            var file = classRef.selectedNodes[0]
          }
          let previewFromUpload = file["previewFromUpload"];
          if(file["objectType"] != "FE"){
            // this.universalService.fetchJSONContent(); // restricting json calls on evry album file selection and verified 318003(due to which this line was added as a fix)
            if(this.universalService.showPreview == true){
              this.getContextMenuForAlbumEntityPreview(file)
            }else{
              this.getContextMenuForSingleAlbumEntity(file);
            }
            //For video - remove full screen option            
            if (file["mimeType"] === "video") {
              let options = [];
              classRef.topMenuOptions.map((option)=>{
                if(option["onClick"] != "fullScreen"){
                  options.push(option)
                }
              })
              classRef.topMenuOptions = options;
            }
          }
          this.universalService.showLoader = false;
        }else{ // selected items are > 1
          var checkForAlbumFiles = [];
          classRef.selectedNodes.filter(objType=>{
            if(objType["objectType"] != "FE")
            checkForAlbumFiles.push(objType)
          })
          if(checkForAlbumFiles.length>=1){
                // selected files are album files
              this.getContextMenuForMultipleAlbumEntities(checkForAlbumFiles);
          }
          
        }

      }
    }

    
    // this.loggerService.log("topMenu Options are ====>>",classRef.topMenuOptions);
    // this.loggerService.log("moreOptions Options are ====>>",classRef.moreOptionsOnTopMenu);
  }

  getContextMenuForSharedLinkByMe() { 
    var classRef = this.universalService;
    classRef.contextMenuOptions = classRef.contextMenu_Share["singleFile"]["SharedLinkByMeMenu"];
  }
  
  getContextMenuForTeamFolders(file){
    var classRef = this.universalService;
    //based on file["roleCode"]
    let options = [];
    if(file["roleCode"] == "O"){
      options = classRef.contextMenu_MainRepo["teamFolders"]["owner"];
    }
    else if(file["roleCode"] == "E"){
      options = classRef.contextMenu_MainRepo["teamFolders"]["editor"];
    }
    else  {
      options = classRef.contextMenu_MainRepo["teamFolders"]["viewer"];
    }
    classRef.contextMenuOptions = options;
  }

  getContextMenuForInsideTeamFolders(file){
    var roleCode = this.getTFRoleCodeDetail(file["roleCode"]);
    var classRef = this.universalService;    
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["insideTeamFoldersSingleFile"][roleCode]["FolderMenu"];
    classRef.topMenuOptions  = classRef.topMenu_MainRepo["insideTeamFoldersSingleFile"][roleCode]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["insideTeamFoldersSingleFile"][roleCode]["FolderMenu"]["moreOptions"];
  }

  getContextMenuForJioPhoneCallFolders(file){
    var classRef = this.universalService;    
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["jioPhoneCallAI"]["singleFile"]["FolderMenu"];
    classRef.topMenuOptions  = classRef.topMenu_MainRepo["JIO_PHONE_CALL_FILE_MENU"]["singleFile"]["FolderMenu"]["topMenu"];
  }
  
  getContextMenuForInsideTeamFolderSingleEntity(file){
    var roleCode = this.getTFRoleCodeDetail(file["roleCode"]);
    var classRef = this.universalService;
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["insideTeamFoldersSingleFile"][roleCode]["RepoFile_FileMenu"];
    classRef.topMenuOptions  = classRef.topMenu_MainRepo["insideTeamFoldersSingleFile"][roleCode]["RepoFile_FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["insideTeamFoldersSingleFile"][roleCode]["RepoFile_FileMenu"]["moreOptions"];
  }

  getContextMenuForInsidePrivateFolder(file){
    var classRef = this.universalService;    
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["privateFolderSingleFile"]["FolderMenu"];
    classRef.topMenuOptions  = classRef.topMenu_MainRepo["privateFolderSingleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["privateFolderSingleFile"]["FolderMenu"]["moreOptions"];
  }
  getContextMenuForInsidePrivateFolderSingleEntity(file){ 
    var classRef = this.universalService;
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["privateFolderSingleFile"]["RepoFile_FileMenu"];
    classRef.topMenuOptions  = classRef.topMenu_MainRepo["privateFolderSingleFile"]["RepoFile_FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["privateFolderSingleFile"]["RepoFile_FileMenu"]["moreOptions"];
  }
  getContextMenuForInsidePrivateFolderMultipleEntity(file){ 
    var classRef = this.universalService;
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["privateFolderMultipleFile"]["RepoFile_FileMenu"];
    classRef.topMenuOptions  = classRef.topMenu_MainRepo["privateFolderMultipleFile"]["RepoFile_FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["privateFolderMultipleFile"]["RepoFile_FileMenu"]["moreOptions"];
  }


  getContextMenuForMultipleSelected(file){
    var classRef = this.universalService;
    if(this.router.url.includes('/privatefolder')){
      classRef.contextMenuOptions = classRef.contextMenu_MainRepo["privateFolderMultipleFile"]["RepoFile_FileMenu"];
      classRef.topMenuOptions  = classRef.topMenu_MainRepo["privateFolderMultipleFile"]["RepoFile_FileMenu"]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["privateFolderMultipleFile"]["RepoFile_FileMenu"]["moreOptions"];
  
    }else{
      var roleCode = this.getTFRoleCodeDetail(file["roleCode"]);
      classRef.contextMenuOptions = classRef.contextMenu_MainRepo["InsideTeamFoldersMultipleFile"][roleCode]["RepoFile_FileMenu"];
      classRef.topMenuOptions  = classRef.topMenu_MainRepo["InsideTeamFoldersMultipleFile"][roleCode]["RepoFile_FileMenu"]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["InsideTeamFoldersMultipleFile"][roleCode]["RepoFile_FileMenu"]["moreOptions"];
    }
  }

  getContextMenuForSingleFileEntity(file){
    var classRef = this.universalService
    if(classRef.currentTab == "Person Details"){
      this.getContextMenuForSingleFileEntityForPeople(file);
      return;
    }
    if(classRef.currentTab == "Place Details"){
      this.getContextMenuForSingleFileEntityForPlace(file);
      return;
    }
    if(classRef.currentTab == "DigiLocker"){
      this.getContextMenuForSingleFileEntityForDigiLocker(file);
      return;
    }

    if(classRef.currentTab == "JioPhoneCallAI"){
      this.getContextMenuForSingleFileEntityForJioPhoneCallAI();
      return;
    }

    if (this.router.url.includes('/teamfolders/') || this.router.url.includes('/search/tf/')){
      this.getContextMenuForInsideTeamFolderSingleEntity(file)
    }else if (this.router.url.includes('/privatefolder')){
      this.getContextMenuForInsidePrivateFolderSingleEntity(file)
    }else{
      // if it is a repo file and marked as favorite
      if(file["isFavorite"] == true){ 
        classRef.contextMenuOptions = (file["mimeType"] == 'image' || file["mimeType"] == 'video') ? classRef.contextMenu_MainRepo["singleFile"]["RepoFile_Favorited_FileMenu"] : classRef.contextMenu_MainRepo["singleFile"]["RepoFile_Other_Than_Image_And_Video_Favorited_FileMenu"];
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Favorited_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu =  (file["mimeType"] == 'image' || file["mimeType"] == 'video') ? classRef.topMenu_MainRepo["singleFile"]["RepoFile_Favorited_FileMenu"]["moreOptions"] : classRef.topMenu_MainRepo["singleFile"]["RepoFile_Favorited_FileMenu"]["moreOptions_Other_Than_Images_And_Videos"];
      }
      // if it is a repo file and not marked as favorite
      else if(!file["isFavorite"]){ 
        classRef.contextMenuOptions = (file["mimeType"] == 'image' || file["mimeType"] == 'video') ? classRef.contextMenu_MainRepo["singleFile"]["RepoFile_FileMenu"] : classRef.contextMenu_MainRepo["singleFile"]["RepoFile_Other_Than_Image_And_Video_FileMenu"];
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = (file["mimeType"] == 'image' || file["mimeType"] == 'video') ? classRef.topMenu_MainRepo["singleFile"]["RepoFile_FileMenu"]["moreOptions"] : classRef.topMenu_MainRepo["singleFile"]["RepoFile_FileMenu"]["moreOptions_Other_Than_Images_And_Videos"];
      }
    }
    
    setTimeout(()=>{
      if(this.universalService.listView ){
        let ele = (document.querySelector('.ag-root-wrapper')) as any
        if(ele){
          // ele.click()
        }
      }
    },500)

  }

  getContextMenuForSingleFileEntityForPeople(file){
    var classRef = this.universalService;
    classRef.contextMenuOptions = file["isFavorite"]?classRef.contextMenu_MainRepo["peopleTab"]["singleFile"]["FileMenu_Favorited"]:classRef.contextMenu_MainRepo["peopleTab"]["singleFile"]["FileMenu"];
    classRef.topMenuOptions = classRef.topMenu_MainRepo["peopleTab"]["singleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = file["isFavorite"]?classRef.topMenu_MainRepo["peopleTab"]["singleFile"]["FileMenu_Favorited"]["moreOptions"]:classRef.topMenu_MainRepo["peopleTab"]["singleFile"]["FileMenu"]["moreOptions"];
  }
  getContextMenuForSingleFileEntityForPlace(file){
    var classRef = this.universalService;
    classRef.contextMenuOptions = file["isFavorite"]?classRef.contextMenu_MainRepo["placeTab"]["singleFile"]["FileMenu_Favorited"]:classRef.contextMenu_MainRepo["placeTab"]["singleFile"]["FileMenu"];
    classRef.topMenuOptions = classRef.topMenu_MainRepo["placeTab"]["singleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = file["isFavorite"]?classRef.topMenu_MainRepo["placeTab"]["singleFile"]["FileMenu_Favorited"]["moreOptions"]:classRef.topMenu_MainRepo["placeTab"]["singleFile"]["FileMenu"]["moreOptions"];
  }
  getContextMenuForSingleFileEntityForDigiLocker(file){
    var classRef = this.universalService;
    classRef.topMenuOptions = classRef.topMenu_MainRepo["DIGI_FILE_MENU"]["singleFile"]["topMenu"];
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["digiLocker"]["singleFile"]["FileMenu"];
  }  

  getContextMenuForSingleFileEntityPreviewForDigiLocker(file){
    var classRef = this.universalService;
    classRef.topMenuOptions = classRef.topMenu_MainRepo["DIGI_FILE_MENU"]["previewFileMenu"]["topMenu"];
  }

  getContextMenuForSingleFileEntityForJioPhoneCallAI(){
    var classRef = this.universalService;
    classRef.topMenuOptions = classRef.topMenu_MainRepo["JIO_PHONE_CALL_FILE_MENU"]["singleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["jioPhoneCallAI"]["singleFile"]["FileMenu"];
  }

  getContextMenuForSingleFolderEntityForJioPhoneCallAI(){
    var classRef = this.universalService;
    classRef.topMenuOptions = classRef.topMenu_MainRepo["JIO_PHONE_CALL_FILE_MENU"]["singleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["jioPhoneCallAI"]["singleFile"]["FolderMenu"];
  }

  getContextMenuForSingleFileEntityPreviewForJioPhoneCallAI(){
    var classRef = this.universalService;
    classRef.topMenuOptions = classRef.topMenu_MainRepo["JIO_PHONE_CALL_FILE_MENU"]["previewFileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
  }

  getContextMenuForSingleAlbumEntity(file){
    var classRef = this.universalService
    // if the user is file owner or album owner
    if(classRef.activeRepo == ActiveRepo.INVITE){
      classRef.topMenuOptions = classRef.topMenu_MainRepo["albumFile_Invite"];
      return
    }
    if(file["isLoggedInUsrAlbumOwner"]== true || (file["isLoggedInUsrAlbumOwner"]== false && file["isLoggedInUsrFileOwner"] == true) ){

      // if it is a album file and image and marked as favorite and image is not set as album cover photo 
      if(file["isFavorite"] == true && file["format"]=="image" && file["objectKey"] != classRef.currentAlbum?.["boardCoverPicObjectKey"]){ 
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["albumFile_Favorited_Image_FileMenu_albumOwner"]; 
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_Favorited_Image_FileMenu_albumOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_Favorited_Image_FileMenu_albumOwner"]["moreOptions"];
      }

      /* if it is a album file and favorited
      Case 1: not image(it may be audio/video/document)
                      or
      Case 2: image and it is already set as album cover photo
      */ 
      else if(file["isFavorite"] == true && (file["format"]!="image" || (file["format"]=="image" && file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]))){ // if it is a album file and not image and marked as favorite
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["albumFile_Favorited_Other_Type_FileMenu_albumOwner"]; 
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_Favorited_Other_Type_FileMenu_albumOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_Favorited_Other_Type_FileMenu_albumOwner"]["moreOptions"];
      }

      // if it is a album file and image and not marked as favorite and image is not set as album cover photo 
      else if(!file["isFavorite"] && file["format"]=="image" && file["objectKey"] != classRef.currentAlbum?.["boardCoverPicObjectKey"]){  // if it is a album file and image and not marked as favorite
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["albumFile_Image_FileMenu_albumOwner"]; 
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_Image_FileMenu_albumOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_Image_FileMenu_albumOwner"]["moreOptions"];
        
      }

      /* if it is a album file and not favorited
      Case 1: not image(it may be audio/video/document)
                      or
      Case 2: image and it is already set as album cover photo
      */ 
      else if(!file["isFavorite"] && (file["format"]!="image" || (file["format"]=="image" && file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]))){  // if it is a album file and not image and not marked as favorite
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["albumFile_Other_Type_FileMenu_albumOwner"]; 
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_Other_Type_FileMenu_albumOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_Other_Type_FileMenu_albumOwner"]["moreOptions"];
        
      }

    }
    // if the user is not file owner and not album owner, but a member of the album
    else if(file["isLoggedInUsrAlbumOwner"]== false && file["isLoggedInUsrFileOwner"] == false){
      // if it is a album file and image and marked as favorite and image is not set as album cover photo 
      if(file["isFavorite"] == true && file["format"]=="image" && file["objectKey"] != classRef.currentAlbum?.["boardCoverPicObjectKey"]){ 
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["albumFile_Favorited_Image_FileMenu_notOwner"]; 
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_Favorited_Image_FileMenu_notOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_Favorited_Image_FileMenu_notOwner"]["moreOptions"];
      }

      /* if it is a album file and favorited
      Case 1: not image(it may be audio/video/document)
                      or
      Case 2: image and it is already set as album cover photo
      */ 
      else if(file["isFavorite"] == true && (file["format"]!="image" || (file["format"]=="image" && file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]))){ // if it is a album file and not image and marked as favorite
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["albumFile_Favorited_Other_Type_FileMenu_notOwner"]; 
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_Favorited_Other_Type_FileMenu_notOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_Favorited_Other_Type_FileMenu_notOwner"]["moreOptions"];
      }

      // if it is a album file and image and not marked as favorite and image is not set as album cover photo 
      else if(!file["isFavorite"] && file["format"]=="image" && file["objectKey"] != classRef.currentAlbum?.["boardCoverPicObjectKey"]){  // if it is a album file and image and not marked as favorite
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["albumFile_Image_FileMenu_notOwner"]; 
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_Image_FileMenu_notOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_Image_FileMenu_notOwner"]["moreOptions"];
        
      }

      /* if it is a album file and not favorited
      Case 1: not image(it may be audio/video/document)
                      or
      Case 2: image and it is already set as album cover photo
      */ 
      else if(!file["isFavorite"] && (file["format"]!="image" || (file["format"]=="image" && file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]))){  // if it is a album file and not image and not marked as favorite
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["singleFile"]["albumFile_Other_Type_FileMenu_notOwner"]; 
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_Other_Type_FileMenu_notOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_Other_Type_FileMenu_notOwner"]["moreOptions"];
        
      }
    }
    if(file["isLoggedInUsrFileOwner"] == false){
      var findRenameOptionContextMenu = classRef.contextMenuOptions.find(opt=>opt["menuItem"] == "Rename");
      var findRenameOnMoreOptionsOnTopMenu = classRef.moreOptionsOnTopMenu.find(opt=>opt["menuItem"] == "Rename");
      if(findRenameOptionContextMenu){
        var index = classRef.contextMenuOptions.indexOf(findRenameOptionContextMenu);
        if(index>=0){
          classRef.contextMenuOptions.splice(index,1);
        }
      }

      if(findRenameOnMoreOptionsOnTopMenu){
        var index = classRef.moreOptionsOnTopMenu.indexOf(findRenameOnMoreOptionsOnTopMenu);
        if(index>=0){
          classRef.moreOptionsOnTopMenu.splice(index,1);
        }
      }
    }
  }

  async getContextMenuForFavoritesTabSingleAlbumFile(file){
    var classRef = this.universalService;
    if(window.location.href.indexOf("albums") > -1){
      this.findFileOwner();
      if(this.filesNotOwnedByUser.length == classRef.selectedNodes.length){ // just member of the album
        classRef.contextMenuOptions = this.favoritesMenu["albumFile"]["contextMenu"]; 
        classRef.topMenuOptions = this.favoritesMenu["albumFile"]["topMenu"];
        classRef.moreOptionsOnTopMenu = this.favoritesMenu["albumFile"]["moreOptions"];
      } else {
        classRef.contextMenuOptions = this.favoritesMenu["albumFile_Owner"]["contextMenu"]; 
        classRef.topMenuOptions = this.favoritesMenu["albumFile_Owner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = this.favoritesMenu["albumFile_Owner"]["moreOptions"];
      }
    }else{
      classRef.contextMenuOptions = this.favoritesMenu["singleFile"]["contextMenu"]; 
      classRef.topMenuOptions = this.favoritesMenu["singleFile"]["topMenu"];
      classRef.moreOptionsOnTopMenu = this.favoritesMenu["singleFile"]["moreOptions"];
    }
  }

  


  getContextMenuForMultipleFileEntities(checkFavoritedFiles){
    var classRef = this.universalService
    var showAddToAlbumOption = this.universalService.checkIfImageAndVideosExistInSelection();
    if(classRef.currentTab == "Person Details"){
      this.getContextMenuForMultipleFileEntitiesForPeople(checkFavoritedFiles);
      return
    }
    if(classRef.currentTab == "Place Details"){
      this.getContextMenuForMultipleFileEntitiesForPlace(checkFavoritedFiles);
      return
    }
    if(classRef.currentTab == "DigiLocker"){
      this.getContextMenuForMultipleFileEntitiesForDigiLocker(checkFavoritedFiles);
      return
    }
    if(classRef.currentTab == "JioPhoneCallAI"){
      this.getContextMenuForMultipleFileEntitiesForJioPhoneCallAI();
      return
    }
    // all the selected repo files are marked as favorite
    if(checkFavoritedFiles.length == classRef.selectedNodes.length){ 
      classRef.contextMenuOptions = showAddToAlbumOption ? classRef.contextMenu_MainRepo["multipleFile"]["RepoFile_Favorited_FileMenu"] : classRef.contextMenu_MainRepo["multipleFile"]["RepoFile_Other_Than_And_Video_Favorited_FileMenu"] 
      classRef.topMenuOptions = classRef.topMenu_MainRepo["multipleFile"]["RepoFile_Favorited_FileMenu"]["topMenu"];
      classRef.moreOptionsOnTopMenu = showAddToAlbumOption ? classRef.topMenu_MainRepo["multipleFile"]["RepoFile_Favorited_FileMenu"]["moreOptions"] : classRef.topMenu_MainRepo["multipleFile"]["RepoFile_Favorited_FileMenu"]["moreOptions_Other_Than_Images_And_Videos"];
    }

    // only few of the selected repo files are marked as favorite
    else { 
      classRef.contextMenuOptions = showAddToAlbumOption ? classRef.contextMenu_MainRepo["multipleFile"]["RepoFile_FileMenu"] : classRef.contextMenu_MainRepo["multipleFile"]["RepoFile_Other_Than_Image_And_Video_FileMenu"];
      classRef.topMenuOptions = classRef.topMenu_MainRepo["multipleFile"]["RepoFile_FileMenu"]["topMenu"];
      classRef.moreOptionsOnTopMenu = showAddToAlbumOption ? classRef.topMenu_MainRepo["multipleFile"]["RepoFile_FileMenu"]["moreOptions"] : classRef.topMenu_MainRepo["multipleFile"]["RepoFile_FileMenu"]["moreOptions_Other_Than_Images_And_Videos"];
      
    }
  }

  getContextMenuForMultipleAlbumEntities(checkFavoritedFiles){
    var classRef = this.universalService
    if(this.universalService.activeRepo == ActiveRepo.INVITE){
       classRef.topMenuOptions = classRef.topMenu_MainRepo["albumFile_Invite"];
       return
    }
    if(this.filesNotOwnedByUser.length == classRef.selectedNodes.length){ // just member of the album
      // all the selected album files are marked as favorite
      if(checkFavoritedFiles.length == classRef.selectedNodes.length){
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["multipleFile"]["albumFile_Favorited_FileMenu_notOwner"];
        classRef.topMenuOptions = classRef.topMenu_MainRepo["multipleFile"]["albumFile_Favorited_FileMenu_notOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = [];
      }
      // only few of the selected album files are marked as favorite
      else { 
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["multipleFile"]["albumFile_FileMenu_notOwner"];
        classRef.topMenuOptions = classRef.topMenu_MainRepo["multipleFile"]["albumFile_FileMenu_notOwner"]["topMenu"];
        classRef.moreOptionsOnTopMenu = [];
      }
    }else{
      // all the selected album files are marked as favorite
      if(checkFavoritedFiles.length == classRef.selectedNodes.length){
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["multipleFile"]["albumFile_Favorited_FileMenu"];
        classRef.topMenuOptions = classRef.topMenu_MainRepo["multipleFile"]["albumFile_Favorited_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = [];
      }
      // only few of the selected album files are marked as favorite
      else { 
        classRef.contextMenuOptions = classRef.contextMenu_MainRepo["multipleFile"]["albumFile_FileMenu"];
        classRef.topMenuOptions = classRef.topMenu_MainRepo["multipleFile"]["albumFile_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = [];
      }
    }
  }

  getContextMenuForFavoritesTabMultipleAlbumFiles(checkFavoritedFiles){
    var classRef = this.universalService;
    classRef.contextMenuOptions = this.favoritesMenu["multipleFile"]["contextMenu"];
    classRef.topMenuOptions = this.favoritesMenu["multipleFile"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
  }

  getContextMenuForMultipleFileEntitiesForPeople(checkFavoritedFiles){
      var classRef = this.universalService;
     // all the selected repo files are marked as favorite
     if(checkFavoritedFiles.length == classRef.selectedNodes.length){ 
      classRef.contextMenuOptions = classRef.contextMenu_MainRepo["peopleTab"]["multipleFile"]["FileMenu_Favorited"]
      classRef.topMenuOptions = classRef.topMenu_MainRepo["peopleTab"]["multipleFile"]["FileMenu_Favorited"]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["peopleTab"]["multipleFile"]["FileMenu_Favorited"]["moreOptions"];
    }

    // only few of the selected repo files are marked as favorite
    else { 
      classRef.contextMenuOptions = classRef.contextMenu_MainRepo["peopleTab"]["multipleFile"]["FileMenu"];
      classRef.topMenuOptions = classRef.topMenu_MainRepo["peopleTab"]["multipleFile"]["FileMenu"]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["peopleTab"]["multipleFile"]["FileMenu"]["moreOptions"];
      
    }
  }
  getContextMenuForMultipleFileEntitiesForPlace(checkFavoritedFiles){
    var classRef = this.universalService;
   // all the selected repo files are marked as favorite
   if(checkFavoritedFiles.length == classRef.selectedNodes.length){ 
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["placeTab"]["multipleFile"]["FileMenu_Favorited"]
    classRef.topMenuOptions = classRef.topMenu_MainRepo["placeTab"]["multipleFile"]["FileMenu_Favorited"]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["placeTab"]["multipleFile"]["FileMenu_Favorited"]["moreOptions"];
  }

  // only few of the selected repo files are marked as favorite
  else { 
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["placeTab"]["multipleFile"]["FileMenu"];
    classRef.topMenuOptions = classRef.topMenu_MainRepo["placeTab"]["multipleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["placeTab"]["multipleFile"]["FileMenu"]["moreOptions"];
    
  }
}

  getContextMenuForMultipleFileEntitiesForDigiLocker(checkFavoritedFiles){
    var classRef = this.universalService;
    classRef.topMenuOptions = classRef.topMenu_MainRepo["DIGI_FILE_MENU"]["multipleFile"]["topMenu"];
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["digiLocker"]["multipleFile"]["FileMenu"];
  }

  getContextMenuForMultipleFileEntitiesForJioPhoneCallAI(){
    var classRef = this.universalService;
    classRef.topMenuOptions = classRef.topMenu_MainRepo["JIO_PHONE_CALL_FILE_MENU"]["multipleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["jioPhoneCallAI"]["multipleFile"]["FileMenu"];
  }

  getContextMenuForMultipleFolderEntitiesForJioPhoneCallAI(){
    var classRef = this.universalService;
    classRef.topMenuOptions = classRef.topMenu_MainRepo["JIO_PHONE_CALL_FILE_MENU"]["multipleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["jioPhoneCallAI"]["multipleFile"]["FolderMenu"];
  }
  
  getContextMenuForFileEntityPreview(file){ 
    var classRef = this.universalService;
    let previewFromUpload = file["previewFromUpload"];
    if(this.router.url.includes('/shared/') && !previewFromUpload){
      return;
    }else if(!previewFromUpload && (classRef.currentTab == "Person Details")){
      this.getContextMenuForFileEntityPeoplePreview(file);
      return
    }else if(!previewFromUpload && (classRef.currentTab == "Place Details")){
      this.getContextMenuForFileEntityPlacePreview(file);
      return
    }
    if(classRef.topMenu_MainRepo != undefined ) {
      // file preview is open and is an image/video and is  favorited
      if(file["isFavorite"]== true && (file["format"]=="image" || file["format"]=="video")){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Image_Favorited_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Image_Favorited_Preview_FileMenu"]["moreOptions"];
      }

      // file preview is open from audio filter and is audio type and is favorited
      else if(file["isFavorite"]== true && (file["format"]=="audio") && this.universalService.currentTab == 'audio'){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Audio_Favorited_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Audio_Favorited_Preview_FileMenu"]["moreOptions"];
      }
      // file preview is open from  repo and is audio type and is favorited
      else if(file["isFavorite"]== true && (file["format"]=="audio") && this.universalService.currentTab != 'audio'){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Favorited_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Favorited_Preview_FileMenu"]["moreOptions"];
      }

      // file preview is open and is other than image/video/Document and is favorited
      else if(file["isFavorite"]== true && (file["format"]!="image" && file["format"]!="video" && file["format"] != 'Document' && file["format"]  != 'SpreadSheet' && file["format"]  != 'Presentation' && file["format"] != 'text' && file["format"] != 'MSOfficeDocument')){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Favorited_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Favorited_Preview_FileMenu"]["moreOptions"];
      }
      
      // file preview is open and is an image/video and is not favorited
      else if( !file["isFavorite"] && (file["format"]=="image" || file["format"]=="video")){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Image_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Image_Preview_FileMenu"]["moreOptions"];
      }

      // file preview is open from audio filter and is an audio and is not favorited 
      else if( !file["isFavorite"] && (file["format"]=="audio") && this.universalService.currentTab == 'audio'){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Audio_Preview_FileMenu"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Audio_Preview_FileMenu"]["moreOptions"];
      }
      // file preview is open from audio filter and is an audio and is not favorited
      else if(!file["isFavorite"] && (file["format"]=="audio") && this.universalService.currentTab != 'audio'){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Preview_FileMenu"]["moreOptions"];
      }
      
      // file preview is open and is an not image/video/Document and is not favorited
      else if(!file["isFavorite"] && (file["format"]!="image" && file["format"]!="video" && file["format"] != 'Document' && file["format"]  != 'SpreadSheet' && file["format"]  != 'Presentation' && file["format"] != 'text' && file["format"] != 'MSOfficeDocument')){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Preview_FileMenu"]["moreOptions"];
      }
      //file preview is open and is document and is not favorited
      else if(!file["isFavorite"] && (file["format"] == 'Document' || file["format"]  == 'SpreadSheet' || file["format"]  == 'Presentation' || file["format"]   == 'text' || file["format"] == 'MSOfficeDocument')){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Document_Type_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Document_Type_Preview_FileMenu"]["moreOptions"];
      }
      //file preview is open and is document and is favorited
      else if(file["isFavorite"]== true && (file["format"] == 'Document' || file["format"]  == 'SpreadSheet' || file["format"]  == 'Presentation' || file["format"]   == 'text' || file["format"] == 'MSOfficeDocument')){
        classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Document_Type_Favorited_Preview_FileMenu"]["topMenu"];
        classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Document_Type_Favorited_Preview_FileMenu"]["moreOptions"];
      }
    }
    classRef.showLoader = false;
  }

  getContextMenuForFileEntityPreviewInTeamFolder(file){
    var classRef = this.universalService;
    var roleCode = this.getTFRoleCodeDetail(file["roleCode"]);

    // file preview is open and is an image/video and is not favorited
    if((file["format"]=="image" || file["format"]=="video")){
      classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Image_Preview_FileMenu"]["insideTeamFolder"][roleCode]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Image_Preview_FileMenu"]["insideTeamFolder"][roleCode]["moreOptions"];
    }

    // file preview is open from audio filter and is an audio and is not favorited 
    else if((file["format"]=="audio") ){
      classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Audio_Preview_FileMenu"]["insideTeamFolder"][roleCode]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Audio_Preview_FileMenu"]["insideTeamFolder"][roleCode]["moreOptions"];
    }
    
    // file preview is open and is an not image/video/Document and is not favorited
    else if((file["format"]!="image" && file["format"]!="video" && file["format"] != 'Document' && file["format"]  != 'SpreadSheet' && file["format"]  != 'Presentation' && file["format"] != 'text' && file["format"] != 'MSOfficeDocument')){
      classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Preview_FileMenu"]["insideTeamFolder"][roleCode]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Preview_FileMenu"]["insideTeamFolder"][roleCode]["moreOptions"];
    }
    //file preview is open and is document and is not favorited
    else if((file["format"] == 'Document' || file["format"]  == 'SpreadSheet' || file["format"]  == 'Presentation' || file["format"]   == 'text' || file["format"] == 'MSOfficeDocument')){
      classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Document_Type_Preview_FileMenu"]["insideTeamFolder"][roleCode]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Document_Type_Preview_FileMenu"]["insideTeamFolder"][roleCode]["moreOptions"];
    }
    classRef.showLoader = false;
  }

  getContextMenuForFileEntityPreviewInPrivateFolder(file){
    var classRef = this.universalService;
   
    // file preview is open and is an image/video and is not favorited
    if((file["format"]=="image" || file["format"]=="video")){
      classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Image_Preview_FileMenu"]["insidePrivateFolder"]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Image_Preview_FileMenu"]["insidePrivateFolder"]["moreOptions"];
    }

    // file preview is open from audio filter and is an audio and is not favorited 
    else if((file["format"]=="audio") ){
      
      classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Audio_Preview_FileMenu"]["insidePrivateFolder"]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Audio_Preview_FileMenu"]["insidePrivateFolder"]["moreOptions"];
    }
    
    // file preview is open and is an not image/video/Document and is not favorited
    else if((file["format"]!="image" && file["format"]!="video" && file["format"] != 'Document' && file["format"]  != 'SpreadSheet' && file["format"]  != 'Presentation' && file["format"] != 'text')){
      classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Preview_FileMenu"]["insidePrivateFolder"]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Other_Type_Preview_FileMenu"]["insidePrivateFolder"]["moreOptions"];
    }
    //file preview is open and is document and is not favorited
    else if((file["format"] == 'Document' || file["format"]  == 'SpreadSheet' || file["format"]  == 'Presentation' || file["format"]   == 'text')){
      classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Document_Type_Preview_FileMenu"]["insidePrivateFolder"]["topMenu"];
      classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["RepoFile_Document_Type_Preview_FileMenu"]["insidePrivateFolder"]["moreOptions"];
    }
    classRef.showLoader = false;
  }

  getContextMenuForAlbumEntityPreview(file){
    var classRef = this.universalService;
    if(classRef.activeRepo == ActiveRepo.INVITE){
      classRef.topMenuOptions =classRef.topMenu_MainRepo["albumFile_invite_Preview"]["topMenu"];
      return
    }
    let previewFromUpload = file["previewFromUpload"]
    if(!previewFromUpload && this.router.url.includes('/favorites/')){
      if(this.filesNotOwnedByUser.length == classRef.selectedNodes.length){
        classRef.moreOptionsOnTopMenu = this.favoritesMenu["singleFile"]["preview_Image_Options"]["moreOptions_NotOwner"];
      } else {
        classRef.moreOptionsOnTopMenu = this.favoritesMenu["singleFile"]["preview_Image_Options"]["moreOptions_Owner"];
      }

      if(file["mimeType"]!='image' && file["mimeType"]!='video'){
        classRef.topMenuOptions = this.favoritesMenu["singleFile"]["preview_OtherType_Options"]["topMenu"];
      }else{
        classRef.topMenuOptions = this.favoritesMenu["singleFile"]["preview_Image_Options"]["topMenu"];
      }
    }else{
      if(file["isLoggedInUsrAlbumOwner"]== true || (file["isLoggedInUsrAlbumOwner"]== false && file["isLoggedInUsrFileOwner"] == true)){
        // if object type is image and favorited and not set as cover photo
        if(file["isFavorite"] && file["format"] == 'image' && file["objectKey"] != classRef.currentAlbum?.["boardCoverPicObjectKey"]){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_NonCoverPhoto_Favorited_Preview"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_NonCoverPhoto_Favorited_Preview"]["moreOptions"];
        }

        // if object type is image and not favorited and not set as cover photo
        else if(!file["isFavorite"] && file["format"] == 'image' && file["objectKey"] != classRef.currentAlbum?.["boardCoverPicObjectKey"]){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_NonCoverPhoto_Preview"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_NonCoverPhoto_Preview"]["moreOptions"];
        }

        /*
        case 1: 
        type is image, not favorited and it is set as the cover photo

        case 2: 
        type is video, not favorited
        */
        else if(!file["isFavorite"] && (file["format"] == 'video' || (file["format"] == 'image' && file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]))){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_CoverPhoto_Preview"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_CoverPhoto_Preview"]["moreOptions"];
        }

        /*
        case 1: 
        type is image, favorited and it is set as the cover photo

        case 2: 
        type is video, favorited
        */

        else if(file["isFavorite"] && (file["format"] == 'video' || (file["format"] == 'image' && file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]))){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_CoverPhoto_Favorited_Preview"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_CoverPhoto_Favorited_Preview"]["moreOptions"];
        }

        /* type is other than image,video, not favorited */
        else if(!file["isFavorite"] && (file["format"] != 'video' && file["format"] != 'image')){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_OtherType_Preview"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_OtherType_Preview"]["moreOptions"];
        }

        /* type is other than image,video, favorited */
        else if(file["isFavorite"] && (file["format"] != 'video' && file["format"] != 'image')){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_OtherType_Favorited_Preview"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_OtherType_Favorited_Preview"]["moreOptions"];
        }
      }else if(file["isLoggedInUsrAlbumOwner"]== false && file["isLoggedInUsrFileOwner"] == false){
        // if object type is image and favorited and not set as cover photo
        if(file["isFavorite"] && file["format"] == 'image' && file["objectKey"] != classRef.currentAlbum?.["boardCoverPicObjectKey"]){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_NonCoverPhoto_Favorited_Preview_notOwner"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_NonCoverPhoto_Favorited_Preview_notOwner"]["moreOptions"];
        }

        // if object type is image and not favorited and not set as cover photo
        else if(!file["isFavorite"] && file["format"] == 'image' && file["objectKey"] != classRef.currentAlbum?.["boardCoverPicObjectKey"]){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_NonCoverPhoto_Preview_notOwner"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_NonCoverPhoto_Preview_notOwner"]["moreOptions"];
        }

        /*
        case 1: 
        type is image, not favorited and it is set as the cover photo

        case 2: 
        type is video, not favorited
        */
        else if(!file["isFavorite"] && (file["format"] == 'video' || (file["format"] == 'image' && file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]))){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_CoverPhoto_Preview_notOwner"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_CoverPhoto_Preview_notOwner"]["moreOptions"];
        }

        /*
        case 1: 
        type is image, favorited and it is set as the cover photo

        case 2: 
        type is video, favorited
        */

        else if(file["isFavorite"] && (file["format"] == 'video' || (file["format"] == 'image' && file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]))){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_CoverPhoto_Favorited_Preview_notOwner"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_CoverPhoto_Favorited_Preview_notOwner"]["moreOptions"];
        }

        /* type is other than image,video, not favorited */
        else if(!file["isFavorite"] && (file["format"] != 'video' && file["format"] != 'image')){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_OtherType_Preview_notOwner"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_OtherType_Preview_notOwner"]["moreOptions"];
        }

        /* type is other than image,video, favorited */
        else if(file["isFavorite"] && (file["format"] != 'video' && file["format"] != 'image')){
          classRef.topMenuOptions = classRef.topMenu_MainRepo["singleFile"]["albumFile_OtherType_Favorited_Preview_notOwner"]["topMenu"];
          classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["singleFile"]["albumFile_OtherType_Favorited_Preview_notOwner"]["moreOptions"];
        }
      }
    }
    if(file["isLoggedInUsrFileOwner"] && file["isLoggedInUsrFileOwner"] == false){
      var findRenameOnMoreOptionsOnTopMenu = classRef.moreOptionsOnTopMenu.find(opt=>opt["menuItem"] == "Rename");
      if(findRenameOnMoreOptionsOnTopMenu){
        var index = classRef.moreOptionsOnTopMenu.indexOf(findRenameOnMoreOptionsOnTopMenu);
        if(index>=0){
          classRef.moreOptionsOnTopMenu.splice(index,1);
        }
      }
    }
  }

  getContextMenuForFileEntityPeoplePreview(file){
    var classRef = this.universalService;
    var favMenu  = "";
    if(file["isFavorite"]){
      favMenu = "FileMenu_Favorited_preview"
    }else{
      favMenu = "FileMenu_preview"
    }
    classRef.topMenuOptions = classRef.topMenu_MainRepo["peopleTab"]["singleFile"][favMenu]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["peopleTab"]["singleFile"][favMenu]["moreOptions"];
  }
  getContextMenuForFileEntityPlacePreview(file){
    var classRef = this.universalService;
    var favMenu  = "";
    if(file["isFavorite"]){
      favMenu = "FileMenu_Favorited_preview"
    }else{
      favMenu = "FileMenu_preview"
    }
    classRef.topMenuOptions = classRef.topMenu_MainRepo["placeTab"]["singleFile"][favMenu]["topMenu"];
    classRef.moreOptionsOnTopMenu = classRef.topMenu_MainRepo["placeTab"]["singleFile"][favMenu]["moreOptions"];
  }
  getContextMenuForTrashFiles(){
    var classRef = this.universalService;
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["Trash_FileMenu"];
    classRef.topMenuOptions = classRef.contextMenu_MainRepo["Trash_FileMenu"];
  }


  // CONTEXT MENU FOR SHARED FILES START

  decideTabNameFromSharedFiles(){
    var url = window.location.href;
    let file = this.universalService.selectedFile;
    if(((!file && url.includes('sharedbyme')) || !file?.previewFromUpload && url.includes('sharedbyme')) || (file?.previewFromUpload && file?.locationOfUpload == 'sharedbyme')){
      return 'sent';
    }else if ((!file && url.includes('sharedwithme')) || (!file?.previewFromUpload && url.includes('sharedwithme')) || (file?.previewFromUpload && file?.locationOfUpload == 'sharedwithme')){
      return 'received';
    }
  }


  getContextMenuForSingleSharedFile(file){
    var classRef = this.universalService;
    var tab = this.decideTabNameFromSharedFiles();
    if(tab == 'sent'){
      if(file["editAccess"] == true){
        this.sharedByMeSingleSharedFileContextMenuWithEditAccess(file)
      }else{
        console.log("shared by me cannot have read access, it will always have edit access.")
      }
    }else if (tab == 'received'){
      if(file["editAccess"] == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened  
          this.sharedWithMeSingleSharedFileContextMenuWithEditAccessRootLevel(file)
        }else{
          this.sharedWithMeSingleSharedFileContextMenuWithEditAccess(file)
        }
      }else{
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened 
          this.sharedWithMeSingleSharedFileContextMenuWithReadAccessRootLevel(file)
        }else{
          this.sharedWithMeSingleSharedFileContextMenuWithReadAccess(file)
        }
      }
    }
  }

  sharedByMeSingleSharedFileContextMenuWithEditAccess(file){  //single file shared by me and having edit access
    var classRef = this.universalService;
    if(classRef.showPreview){
      if(file["mimeType"] == 'image'){
        classRef.topMenuOptions = this.sharedByMe["EditAccess"]["singleFile"]["ImagePreviewMenu"]["topMenu"];
      }else{
        classRef.topMenuOptions = this.sharedByMe["EditAccess"]["singleFile"]["OtherMimeTypePreviewMenu"]["topMenu"];
      }
    }else{
      classRef.topMenuOptions = this.sharedByMe["EditAccess"]["singleFile"]["FileMenu"]["topMenu"];
    }
    
    classRef.contextMenuOptions = this.sharedByMe["contextMenu"]["EditAccess"]["singleFile"]["FileMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedByMe["EditAccess"]["singleFile"]["FileMenu"]["moreOptions"];
  }

  sharedWithMeSingleSharedFileContextMenuWithEditAccess(file){ //single file shared with me and having edit access
    var classRef = this.universalService;
    if(classRef.showPreview){
      if(file["mimeType"] == 'image'){
        classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["singleFile"]["ImagePreviewMenu"]["topMenu"];
      }else{
        classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["singleFile"]["OtherMimeTypePreviewMenu"]["topMenu"];
      }
    }else{
      classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["singleFile"]["FileMenu"]["topMenu"];
    }
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["EditAccess"]["singleFile"]["FileMenu"]
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["EditAccess"]["singleFile"]["FileMenu"]["moreOptions"];
  }

  sharedWithMeSingleSharedFileContextMenuWithEditAccessRootLevel(file){
    var classRef = this.universalService;
    if(classRef.showPreview){
      if(file["mimeType"] == 'image'){
        classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["singleFile"]["ImagePreviewMenu"]["topMenu"];
      }else{
        classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["singleFile"]["OtherMimeTypePreviewMenu"]["topMenu"];
      }
    }else{
      classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["singleFile"]["FileMenu"]["topMenu"];
    }
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["EditAccess"]["rootLevelOptions"]["singleFile"]["FileMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["singleFile"]["FileMenu"]["moreOptions"];
  }

  sharedWithMeSingleSharedFileContextMenuWithReadAccess(file){ //single file shared with me and having read access
    var classRef = this.universalService;
    if(classRef.showPreview){
      if(file["mimeType"] == 'image'){
        classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["singleFile"]["ImagePreviewMenu"]["topMenu"];
      }else{
        classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["singleFile"]["OtherMimeTypePreviewMenu"]["topMenu"];
      }
    }else{
      classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["singleFile"]["FileMenu"]["topMenu"];
    }
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["ReadAccess"]["singleFile"]["FileMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["ReadAccess"]["singleFile"]["FileMenu"]
  }

  sharedWithMeSingleSharedFileContextMenuWithReadAccessRootLevel(file){
    var classRef = this.universalService;
    if(classRef.showPreview){
      if(file["mimeType"] == 'image'){
        classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["singleFile"]["ImagePreviewMenu"]["topMenu"];
      }else{
        classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["singleFile"]["OtherMimeTypePreviewMenu"]["topMenu"];
      }
    }else{
      classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["singleFile"]["FileMenu"]["topMenu"];
    }
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["singleFile"]["FileMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["ReadAccess"]["rootLevelOptions"]["singleFile"]["FileMenu"]
  }

  getContextMenuForSingleSharedFolder(file){
    var tab = this.decideTabNameFromSharedFiles();
    if(tab == 'sent'){
      if(file["editAccess"] == true){
        this.sharedByMeSingleSharedFolderContextMenuWithEditAccess()
      }else{
        console.log("shared by me cannot have read access, it will always have edit access.")
      }
    }else if (tab == 'received'){
      if(file["editAccess"] == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeSingleSharedFolderContextMenuWithEditAccessRootLevel()
        }else{
          this.sharedWithMeSingleSharedFolderContextMenuWithEditAccess()
        }
      }else{
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeSingleSharedFolderContextMenuWithReadAccessRootLevel()
        }else{
          this.sharedWithMeSingleSharedFolderContextMenuWithReadAccess()
        }
      }
    }
  }


  sharedByMeSingleSharedFolderContextMenuWithEditAccess(){  //single folder shared by me and having edit access
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedByMe["EditAccess"]["singleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedByMe["EditAccess"]["singleFile"]["FolderMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedByMe["contextMenu"]["EditAccess"]["singleFile"]["FolderMenu"]
  }

  sharedWithMeSingleSharedFolderContextMenuWithEditAccess(){ //single folder shared with me and having edit access
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["singleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["EditAccess"]["singleFile"]["FolderMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["EditAccess"]["singleFile"]["FolderMenu"]
  }

  sharedWithMeSingleSharedFolderContextMenuWithEditAccessRootLevel(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["singleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["singleFile"]["FolderMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["EditAccess"]["rootLevelOptions"]["singleFile"]["FolderMenu"]
  }

  sharedWithMeSingleSharedFolderContextMenuWithReadAccess(){ //single folder shared with me and having read access
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["singleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["ReadAccess"]["singleFile"]["FolderMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["ReadAccess"]["singleFile"]["FolderMenu"]
  }

  sharedWithMeSingleSharedFolderContextMenuWithReadAccessRootLevel(){
     var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["singleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["singleFile"]["FolderMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["ReadAccess"]["rootLevelOptions"]["singleFile"]["FolderMenu"]
  }

  getContextMenuForMultipleSharedFiles(){ 
    var tab = this.decideTabNameFromSharedFiles();
    var classRef = this.universalService;
    classRef.haveEditAccess();
    if(tab == 'sent'){
      if(classRef.hasEditAccess == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedByMeMultipleSharedFilesContextMenuWithEditAccessRootLevel()
        }else{
          this.sharedByMeMultipleSharedFilesContextMenuWithEditAccess()
        }
      }else{
        console.log("shared by me cannot have read access, it will always have edit access.")
      }
    }else if (tab == 'received'){
      if(classRef.hasEditAccess == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeMultipleSharedFilesContextMenuWithEditAccessRootLevel()
        }else{
          this.sharedWithMeMultipleSharedFilesContextMenuWithEditAccess()
        }
      }else{
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeMultipleSharedFilesContextMenuWithReadAccessRootLevel()
        }else{
          this.sharedWithMeMultipleSharedFilesContextMenuWithReadAccess()
        }
      }
    }
  }

  sharedByMeMultipleSharedFilesContextMenuWithEditAccess(){  //multiple files shared by me and having edit access
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedByMe["EditAccess"]["multipleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = this.sharedByMe["contextMenu"]["EditAccess"]["multipleFile"]["FileMenu"];
  }

  sharedByMeMultipleSharedFilesContextMenuWithEditAccessRootLevel(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedByMe["EditAccess"]["rootLevelOptions"]["multipleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = this.sharedByMe["contextMenu"]["EditAccess"]["rootLevelOptions"]["multipleFile"]["FileMenu"];
  }

  sharedWithMeMultipleSharedFilesContextMenuWithEditAccess(){ //multiple files shared with me and having edit access
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["multipleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["EditAccess"]["multipleFile"]["FileMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["EditAccess"]["multipleFile"]["FileMenu"];
  }

  sharedWithMeMultipleSharedFilesContextMenuWithEditAccessRootLevel(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["multipleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["multipleFile"]["FileMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["EditAccess"]["rootLevelOptions"]["multipleFile"]["FileMenu"];
  }

  sharedWithMeMultipleSharedFilesContextMenuWithReadAccess(){ //multiple files shared with me and having read access
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["multipleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["ReadAccess"]["multipleFile"]["FileMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["ReadAccess"]["multipleFile"]["FileMenu"];
  }

  sharedWithMeMultipleSharedFilesContextMenuWithReadAccessRootLevel(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["multipleFile"]["FileMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["multipleFile"]["FileMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["ReadAccess"]["rootLevelOptions"]["multipleFile"]["FileMenu"];
  }

  getContextMenuForMultipleSharedFolders(){
    var tab = this.decideTabNameFromSharedFiles();
    var classRef = this.universalService;
    classRef.haveEditAccess();
    if(tab == 'sent'){
      if(classRef.hasEditAccess == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedByMeMultipleSharedFoldersContextMenuWithEditAccessRootLevel()
        }else{
          this.sharedByMeMultipleSharedFoldersContextMenuWithEditAccess()
        }
      }else{
        console.log("shared by me cannot have read access, it will always have edit access.")
      }
    }else if (tab == 'received'){
      if(classRef.hasEditAccess == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeMultipleSharedFoldersContextMenuWithEditAccessRootLevel()
        }else{
          this.sharedWithMeMultipleSharedFoldersContextMenuWithEditAccess()
        }
      }else{
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeMultipleSharedFoldersContextMenuWithReadAccessRootLevel()
        }else{
        this.sharedWithMeMultipleSharedFoldersContextMenuWithReadAccess()
        }
      }
    }
  }

  getContextMenuForMultipleJioPhoneCallFolders() {
    var classRef = this.universalService;
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = classRef.contextMenu_MainRepo["jioPhoneCallAI"]["multipleFile"]["FolderMenu"];
    classRef.topMenuOptions  = classRef.topMenu_MainRepo["JIO_PHONE_CALL_FILE_MENU"]["multipleFile"]["FolderMenu"]["topMenu"];
  }


  sharedByMeMultipleSharedFoldersContextMenuWithEditAccess(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedByMe["EditAccess"]["multipleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = this.sharedByMe["contextMenu"]["EditAccess"]["multipleFile"]["FolderMenu"];
  }

  sharedByMeMultipleSharedFoldersContextMenuWithEditAccessRootLevel(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedByMe["EditAccess"]["rootLevelOptions"]["multipleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = [];
    classRef.contextMenuOptions = this.sharedByMe["contextMenu"]["EditAccess"]["rootLevelOptions"]["multipleFile"]["FolderMenu"];
  }

  sharedWithMeMultipleSharedFoldersContextMenuWithEditAccess(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["multipleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["EditAccess"]["multipleFile"]["FolderMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["EditAccess"]["multipleFile"]["FolderMenu"];
  }

  sharedWithMeMultipleSharedFoldersContextMenuWithEditAccessRootLevel(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["multipleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["multipleFile"]["FolderMenu"]["moreOptions"];
    classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["EditAccess"]["rootLevelOptions"]["multipleFile"]["FolderMenu"];
  }

  sharedWithMeMultipleSharedFoldersContextMenuWithReadAccess(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["multipleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["ReadAccess"]["multipleFile"]["FolderMenu"]["moreOptions"];
  classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["ReadAccess"]["multipleFile"]["FolderMenu"];
  }

  sharedWithMeMultipleSharedFoldersContextMenuWithReadAccessRootLevel(){
    var classRef = this.universalService;
    classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["multipleFile"]["FolderMenu"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["multipleFile"]["FolderMenu"]["moreOptions"];
  classRef.contextMenuOptions = this.sharedWithMe["contextMenu"]["ReadAccess"]["rootLevelOptions"]["multipleFile"]["FolderMenu"];
  }

  findFileOwner(){
    var classRef = this.universalService;
    this.filesNotOwnedByUser =[];
    classRef.selectedNodes.filter(objType=>{
      if(objType["FullObject"]){
        if(objType["FullObject"]["isLoggedInUsrFileOwner"] == false)
        this.filesNotOwnedByUser.push(objType)
      }else{
        if(objType["isLoggedInUsrFileOwner"] ==  false)
        this.filesNotOwnedByUser.push(objType)
      }
    })
  }

  getTFRoleCodeDetail(code) {
    var roleCode = "viewer";
    if(code == "O"){
      roleCode = "owner";
    } else if(code == "E"){
      roleCode = "editor";
    }
    return roleCode
  }

  fetchJSONContents(){
    var self = this;
    this.http.get(ENV_CONFIG.jsonUrls.favouritesAlbumsDesktop).subscribe(
      suc=>{
        self.favoritesMenu = suc;
      }
    ) 

    this.http.get(ENV_CONFIG.jsonUrls.sharedByMeDesktop).subscribe(
      suc=>{
        self.sharedByMe = suc;
      }
    ) 

    this.http.get(ENV_CONFIG.jsonUrls.sharedWithMeDesktop).subscribe(
      suc=>{
        self.sharedWithMe = suc;
      }
    )
    
    this.http.get(ENV_CONFIG.jsonUrls.officeForWeb).subscribe(
      suc=>{
        self.officeForWeb = suc;
      }
    )
  }

  checkIfOpenWithOfficeForWebOption(file){
    this.universalService.contextMenuOptions.splice(0,1,this.universalService.contextMenu_MainRepo["previewOptions"]);
    this.universalService.moreOptionsOnTopMenu = [...new Set(this.universalService.moreOptionsOnTopMenu)]
    var foundInMoreOption = this.universalService.moreOptionsOnTopMenu.find(opt=>opt["menuItem"] == this.universalService.contextMenu_MainRepo["previewTypes"]["menuItem"]);
    var indexInMoreOptions = this.universalService.moreOptionsOnTopMenu.indexOf(foundInMoreOption);
    if(foundInMoreOption){
      this.universalService.moreOptionsOnTopMenu.splice(indexInMoreOptions,1);
    }
    if(file["format"] == 'image' || file["format"] == 'audio' || file["format"] == 'video') return;
    this.universalService.contextMenuOptions.splice(0,1,this.universalService.contextMenu_MainRepo["previewTypes"]);
    this.universalService.contextMenuMoreOptions = [];
    if(!this.universalService.showPreview){
      this.universalService.contextMenuMoreOptions.push(this.universalService.contextMenu_MainRepo["defaultPreviewOptions"]);
    }
    if((file["OfficeForWebSupported"] && this.universalService.MSOfficeSupportedInModule && ENV_CONSTANTS["constants"]["enableOfficeForWebPreview"]) || (file["OfficeForWebSupported"] && file["previewFromUpload"])){
      var formatType = ""
      if(this.officeForWeb[file.format]){
        formatType = file.format;
      }else{
        formatType = "unknown";
      }
      var foundOption = this.universalService.contextMenuMoreOptions.find(opt=>opt["menuItem"] == this.officeForWeb[formatType]["menuItem"])
      if(!foundOption){
        this.universalService.contextMenuMoreOptions.unshift(this.officeForWeb[formatType]);
      }
    }
    if(this.universalService.contextMenuMoreOptions.length>=1){
      this.universalService.moreOptionsOnTopMenu.unshift(this.universalService.contextMenu_MainRepo["previewTypes"]);
    }
  }


  checkIfManageVersionsIsTobeSupported(file){
    var classRef = this.universalService;
    var foundManageVersionsOptionContextMenu = classRef.contextMenuOptions.find(item=> item["menuItem"] == "Manage Versions");
    var foundManageVersionsOptionMoreOptions = classRef.moreOptionsOnTopMenu.find(item=> item["menuItem"] == "Manage Versions");
    if(foundManageVersionsOptionContextMenu){
      var indx = classRef.contextMenuOptions.indexOf(foundManageVersionsOptionContextMenu);
      classRef.contextMenuOptions.splice(indx,1);
    } 
    if(foundManageVersionsOptionMoreOptions){
      var indx = classRef.moreOptionsOnTopMenu.indexOf(foundManageVersionsOptionMoreOptions);
      classRef.moreOptionsOnTopMenu.splice(indx,1);
    }
    if((this.universalService.manageVersionsSupportedInModule && ENV_CONSTANTS["constants"]["enableManageVersions"]) || (file["versioningSupported"] && file["previewFromUpload"])){
      if(file["format"] == "Document" || file["format"] == "SpreadSheet" || file["format"] == "Presentation" || file["format"] == "text" || file["format"] == "PDF" || file["format"] == "application" || file["format"] == 'MSOfficeDocument'){
        classRef.contextMenuOptions.splice(classRef.contextMenuOptions.length-1,0,classRef.contextMenu_MainRepo["MANAGE_VERSION_OPTION"]);
        classRef.moreOptionsOnTopMenu.splice(classRef.moreOptionsOnTopMenu.length-1,0,classRef.contextMenu_MainRepo["MANAGE_VERSION_OPTION"])
      }
    }
  }

  checkIfPrivateFolderOptionToShow() {
    var classRef = this.universalService;
    var userData = this.localStorageSvc.getUserData(true);
    if(userData == undefined) return;
    if(userData["privateFolder"]  && (userData["privateFolder"]["allowPPF"] != "Y" || userData["privateFolder"]["isPPFEnabled"] != "Y")) { //If private folder not enables, hide repo to PF move option
      var topfound = classRef.topMenuOptions.find(k => k["onClick"] == "moveToPrivateFolder")
      if(topfound){
        var index = classRef.topMenuOptions.indexOf(topfound)
        classRef.topMenuOptions.splice(index,1)
      }
      var contextfound = classRef.contextMenuOptions?.find(k => k["onClick"] == "moveToPrivateFolder")
      if(contextfound){
        var index = classRef.contextMenuOptions.indexOf(contextfound)
        classRef.contextMenuOptions.splice(index,1)
      }
      if(classRef.moreOptionsOnTopMenu != undefined && classRef.moreOptionsOnTopMenu.length > 0 ) {
        var findItem = classRef.moreOptionsOnTopMenu.find(item=>item["onClick"] == "moveToPrivateFolder");
        var index = classRef.moreOptionsOnTopMenu.indexOf(findItem);
        if(index>0){
          classRef.moreOptionsOnTopMenu.splice(index,1)
        }
      }
    }
  }

  getContextMenuOptionsForMemory(){
    var classRef = this.universalService;
    var currentFile = this.universalService.selectedFile
    classRef.topMenuOptions = currentFile["isFavorite"] ? this.universalService.topMenu_MainRepo["MEMORY_MENU"]["topMenu_Favorited"] : this.universalService.topMenu_MainRepo["MEMORY_MENU"]["topMenu"];
    classRef.moreOptionsOnTopMenu = this.universalService.topMenu_MainRepo["MEMORY_MENU"]["moreOptions"];
  }

  getTopMenuForBackupRoute(){
    var classRef = this.universalService;
    
    let menuOption = classRef.topMenu_MainRepo["BACKUP_MENU"]
    if(classRef.selectedNodes[0]?.isBackupDevices == 'Y'){
      classRef.selectedNodes.length == 1 ? classRef.topMenuOptions = menuOption["deviceInfo"] : classRef.topMenuOptions =[];
    }else{
      if(classRef.showPreview){
        classRef.selectedFile["mimeType"] == "image" || classRef.selectedFile["mimeType"] == "video" ? classRef.topMenuOptions = menuOption["isImgOrVideoPreview"] : classRef.topMenuOptions = menuOption["PreviewMenu"];
      }else{
        classRef.selectedNodes.length > 1 ?classRef.topMenuOptions = menuOption["multipleFile"] :classRef.topMenuOptions = menuOption["topMenu"];
      }
    }
    this.checkIfMoreOptionsToBeAddedInTopMenuOptions();
  }

  checkIfMoreOptionsToBeAddedInTopMenuOptions(){
    var classRef = this.universalService;
    if((classRef.selectedFile?.["OfficeForWebSupported"] && this.universalService.MSOfficeSupportedInModule)  || (classRef.selectedFile["OfficeForWebSupported"] && classRef.selectedFile["previewFromUpload"])){ // this is to show open with option on top menu if MS editing is supported for any document
      var checkIfMoreOptionsAlreadyPresentOnTopMenu = classRef.topMenuOptions.find(option=>option["menuItem"] == "More Options");
      if(!checkIfMoreOptionsAlreadyPresentOnTopMenu){
        if(this.universalService.showPreview){
          classRef.topMenuOptions.splice(classRef.topMenuOptions.length-1,0,classRef.topMenu_MainRepo["BACKUP_MENU"]["MORE_OPTIONS"])
        }else{
          classRef.topMenuOptions.push(classRef.topMenu_MainRepo["BACKUP_MENU"]["MORE_OPTIONS"]);
        }
      }
    }
  }

  checkIfShowLocationOption(){
    var classRef = this.universalService;
    var foundInMoreOption = this.universalService.moreOptionsOnTopMenu.find(opt=>opt["menuItem"] == classRef.contextMenu_MainRepo["FILE_LOCATION_OPTION"]["menuItem"]);
    var foundFileLocationOptionContextMenu = classRef.contextMenuOptions.find(item=> item["menuItem"] == classRef.contextMenu_MainRepo["FILE_LOCATION_OPTION"]["menuItem"]);
    var indexInMoreOptions = this.universalService.moreOptionsOnTopMenu.indexOf(foundInMoreOption);
    var indexInContextMenu = this.universalService.contextMenuOptions.indexOf(foundFileLocationOptionContextMenu);
    if(foundInMoreOption){
      this.universalService.moreOptionsOnTopMenu.splice(indexInMoreOptions,1);
    }

    if(foundFileLocationOptionContextMenu){
      this.universalService.contextMenuOptions.splice(indexInContextMenu,1);
    }

    if(this.router.url.includes('/search') || this.universalService.isPreviewOpenFromSearchDropdown) {
      classRef.contextMenuOptions.splice(1,0,classRef.contextMenu_MainRepo["FILE_LOCATION_OPTION"]);
      classRef.moreOptionsOnTopMenu.splice(1,0,classRef.contextMenu_MainRepo["FILE_LOCATION_OPTION"]);
    }
  }


  addEditImageOptionIfImageFileIsSelected(file){
    var classRef = this.universalService;
    var foundInMoreOption = this.universalService.moreOptionsOnTopMenu.find(opt=>opt["menuItem"] == classRef.contextMenu_MainRepo["EDIT_IMAGE_OPTION"]["menuItem"]);
    var foundEditImageOptionContextMenu = classRef.contextMenuOptions.find(item=> item["menuItem"] == classRef.contextMenu_MainRepo["EDIT_IMAGE_OPTION"]["menuItem"]);
    var indexInMoreOptions = this.universalService.moreOptionsOnTopMenu.indexOf(foundInMoreOption);
    var indexInContextMenu = this.universalService.contextMenuOptions.indexOf(foundEditImageOptionContextMenu);
    if(foundInMoreOption){
      this.universalService.moreOptionsOnTopMenu.splice(indexInMoreOptions,1);
    }

    if(foundEditImageOptionContextMenu){
      this.universalService.contextMenuOptions.splice(indexInContextMenu,1);
    }

    if(file["mimeType"] == 'image' && this.universalService.allowPhotoEditInViewBasedOnAccessRights && this.universalService.photoEditSupportedInModule){
      let isExtSupportedForPhotoEdit = ENV_CONFIG["photoEditSupportedExtensions"].some(obj=> {
        return (file["extension"].toLowerCase()).includes(obj);
      })
      if(isExtSupportedForPhotoEdit){
        classRef.contextMenuOptions.splice(1,0,classRef.contextMenu_MainRepo["EDIT_IMAGE_OPTION"]);
        classRef.moreOptionsOnTopMenu.splice(0,0,classRef.contextMenu_MainRepo["EDIT_IMAGE_OPTION"]);
      }
    }
  }


  checkIfUploafFromPreviewAndRemoveUnecessaryOptions(file,moreOptionsOnTopMenu,contextMenuOptions,topMenuOptions){
    if(!file || !file["previewFromUpload"]) return
    this.removeUnnecessaryOptionsFromMoreOptions(moreOptionsOnTopMenu);
    this.removeUnnecessaryOptionsFromContextMenu(contextMenuOptions);
    this.removeUnnecessaryOptionsFromTopmenu(topMenuOptions);
  }


  removeUnnecessaryOptionsFromMoreOptions(moreOptionsOnTopMenu){
    let options = [];
    moreOptionsOnTopMenu.map((option)=>{
      if(!this.universalService.OPERATIONS_WHICH_NEED_UI_UPDATE.includes(option["menuItem"])){
        options.push(option)
      }
    })
    this.universalService.moreOptionsOnTopMenu = options;
  }

  removeUnnecessaryOptionsFromContextMenu(contextMenuOptions){
    let options = [];
    contextMenuOptions.map((option)=>{
      if(!this.universalService.OPERATIONS_WHICH_NEED_UI_UPDATE.includes(option["menuItem"])){
        options.push(option)
      }
    })
    this.universalService.contextMenuOptions = options;
  }

  removeUnnecessaryOptionsFromTopmenu(topMenuOptions){
    let options = [];
    topMenuOptions.map((option)=>{
      if(!this.universalService.OPERATIONS_WHICH_NEED_UI_UPDATE.includes(option["menuItem"])){
        options.push(option)
      }
    })

    this.universalService.topMenuOptions = options;
  }

  removeDownloadOptionFromMenuWhenTheObjectsAreFromDifferentHierarchies(){
    // this function is added specific to search pages as the search results come from different hierarchies and bulk download from server has some limitation on downloading files from different hierarchies
    if(this.router.url.includes("/search") && !this.router.url.includes("/tf")) {
      var findDownloadInContextMenuOptions = this.universalService.contextMenuOptions.find(opt=>opt["menuItem"] == "Download");
      var findDownloadIntopMenuOptions = this.universalService.topMenuOptions.find(opt=>opt["menuItem"] == "Download");
      if(findDownloadInContextMenuOptions){
        let index = this.universalService.contextMenuOptions.indexOf(findDownloadInContextMenuOptions);
        if(index >= 0){
          this.universalService.contextMenuOptions.splice(index,1);
        }
      }

      if(findDownloadIntopMenuOptions){
        let index = this.universalService.topMenuOptions.indexOf(findDownloadIntopMenuOptions);
        if(index >= 0){
          this.universalService.topMenuOptions.splice(index,1);
        }
      }
    }
  }
  removeShareOptionFromMenuWhenMultipleObject(){
    // this function is added specific to search pages as the search results come from different hierarchies and bulk download from server has some limitation on downloading files from different hierarchies
    if(this.router.url.includes("/search") && !this.router.url.includes("/tf")) {
      var findDownloadInContextMenuOptions = this.universalService.contextMenuOptions.find(opt=>opt["menuItem"] == "Share link");
      var findDownloadIntopMenuOptions = this.universalService.topMenuOptions.find(opt=>opt["menuItem"] == "Share link");
      if(findDownloadInContextMenuOptions){
        let index = this.universalService.contextMenuOptions.indexOf(findDownloadInContextMenuOptions);
        if(index >= 0){
          this.universalService.contextMenuOptions.splice(index,1);
        }
      }

      if(findDownloadIntopMenuOptions){
        let index = this.universalService.topMenuOptions.indexOf(findDownloadIntopMenuOptions);
        if(index >= 0){
          this.universalService.topMenuOptions.splice(index,1);
        }
      }
    }
  }

  
}
